import { useMemo } from 'react';
import * as Yup from 'yup';

export const usePasswordValidationSchema = (
  passwordRequirements: { regexp: RegExp; description: string }[],
  showOldPasswordField?: boolean,
  showCodeField?: boolean
) =>
  useMemo(() => {
    const passwordSchema = passwordRequirements.reduce(
      (schema, { regexp }) =>
        schema.matches(
          regexp,
          "Password doesn't meet password policy requirements"
        ),
      Yup.string()
        .required()
        .max(256)
        .matches(
          /^[\S]+.*[\S]+$/,
          'Password cannot start or end with whitespace characters'
        )
        .label('New password')
    );

    return Yup.object().shape({
      ...(showOldPasswordField && {
        oldPassword: Yup.string().required().label('Old password'),
      }),
      ...(showCodeField && {
        code: Yup.string().required().length(6).label('Code'),
      }),
      newPassword: passwordSchema,
      confirmPassword: Yup.string()
        .required()
        .oneOf(
          [Yup.ref('newPassword'), Yup.ref('oldPassword')],
          'New and confirmed passwords must match'
        )
        .label('Confirm password'),
    });
  }, [passwordRequirements, showOldPasswordField, showCodeField]);
